import logo from './logo.svg';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import SessionTimeoutWarning from './components/SessionTimeoutWarning';
import CompanyMasters from './components/CompanyMasters';
import LoginForm from './components/forms/LoginForm';
import SalaryParametersForm from './components/forms/SalaryParametersForm';
import ViewLeaveTypeMaster from './components/forms/ViewLeaveTypeMaster';
import InsertHeaderForm from './components/forms/InsertHeaderForm';
import DataManager from './components/forms/DataManager';
import EmployeeMasters from './components/EmployeeMasters';
import ViewEmployees from './components/forms/ViewEmployees';
import ViewCompanies from './components/forms/ViewCompanies';
import ViewEmployeeRoles from './components/forms/ViewEmployeeRoles';
import ViewApiKeys from './components/forms/ViewApiKeys';
import ViewUsers from './components/forms/ViewUsers';
import ViewAccessRoles from './components/forms/ViewAccessRoles';
import ViewPTSlabs from './components/forms/ViewPTSlabs';
import Reports from './components/Reports';
import Configure from './components/Configure';
import ESIC_Configuration from './components/forms/ESIC_Configuration';
import PF_RulesConfiguration from './components/forms/PF_RulesConfiguration';
import CTC_Configuration from './components/forms/CTC_Configuration';
import EarningAndDeductionMaster from './components/forms/EarningAndDeductionMaster';
import CreatePayroll from './components/forms/CreatePayroll';
import StipendPayroll from './components/forms/StipendPayroll';
import CombineSalaryReport from './components/forms/CombineSalaryReport';
import IncomeTaxReport from './components/forms/IncomeTaxReport';
import ProvidentFundReport from './components/forms/ProvidentFundReport';
import ProfessionalTaxReport from './components/forms/ProfessionalTaxReport';
import BankStatementReport from './components/forms/BankStatementReport';
import ESIStatementReport from './components/forms/ESIStatementReport';
import SeparationRateReport from './components/forms/SeparationRateReport';
import CombineSalaryReportDuration from './components/forms/CombineSalaryReportDuration';
import ExcelFileGeneration from './components/forms/ExcelFileGeneration';
import SalaryReport from './components/forms/SalaryReport';
import StipendReport from './components/forms/StipendReport';
import ViewHolidayMaster from './components/forms/ViewHolidayMaster';
import PDF from './components/PDF';
import SalarySlip from './components/generated/SalarySlip';
import PFReport from './components/generated/PFReport';
import PFSplitECR from './components/generated/PFSplitECR';
import ESIReport from './components/generated/ESIReport';
import ECRTextFile from './components/generated/ECRTextFile';
import CombinedSalary from './components/generated/CombinedSalary';
import IncomeTaxReportGenerated from './components/generated/IncomeTaxReportGenerated';
import EmailSendForm from './components/forms/EmailSendForm';
import WF_ConfigurationForm from './components/forms/WF_ConfigurationForm';
import TDS_Configuration from './components/forms/TDS_Configuration';
import TDS_Configuration_Combined from './components/forms/TDS_Configuration_Combined';
import Gratuity_Configuration from './components/forms/Gratuity_Configuration';
import BankStateReport from './components/generated/BankStateReport';
import BankStatementGenerated from './components/generated/BankStatementGenerated';
import EnterEmail from './components/forgot-password/EnterEmail';
import EnterOTP from './components/forgot-password/EnterOTP';
import EnterNewPassword from './components/forgot-password/EnterNewPassword';
import AnalyticsDashboard from './components/analytics-dashboard/AnalyticsDashboard';
import SignupCompanyForm from './components/forms/SignupCompanyForm';
import SeperationReport from './components/generated/SeperationReport';
import TestCompanyDefinition from './components/TestCompanyDefinition';
import GlobalLoader from './components/GlobalLoader';
import WFStatementReport from './components/forms/WFStatementReport';
import WFReport from './components/generated/WFReport';
import IncomeTax from './components/forms/IncomeTax';
import IncomeTaxRules_Configuration from './components/forms/IncomeTaxRules_Configuration';
import EarningDeductionForm from './components/forms/EarningDeductionForm';
import AuditLogs from './components/forms/AuditLogs';
import ViewInternApprenticeEmployees from './components/forms/ViewInternApprenticeEmployees';
import GratuityReport from './components/forms/GratuityReport';
import GratuityReportGenerated from './components/generated/GratuityReportGenerated';
import TopEmployeesReport from './components/forms/TopEmployeesReport';
import TopEmployeesReportGenerated from './components/generated/TopEmployeesReportGenerated';

const appTheme = createTheme({
  palette: {
    primary: { main: '#0b418e' },
  },
});

function App() {
  return (
    <ThemeProvider theme={appTheme}>
    <div className="App">
    <Navbar />
    <SessionTimeoutWarning />
    <GlobalLoader />

      <Routes>
        <Route path="/" element={<LoginForm/>}/>
        <Route path="" element={<Navigate to="/" replace />} />
        <Route path="dashboard" element={<AnalyticsDashboard />}/>
        <Route path="/create-account" element={<SignupCompanyForm />}/>
        <Route path="/forgot-password" element={<EnterEmail />} />
        <Route path="/enter-otp" element={<EnterOTP />} />
        <Route path="/new-password" element={<EnterNewPassword />} />

        <Route path="company-master" >
          <Route index element={<CompanyMasters/>}/>
          <Route path="view-companies" element={<ViewCompanies />}/>
          <Route path="employee-roles" element={<ViewEmployeeRoles />} />
          <Route path="api-keys" element={<ViewApiKeys />} />
          <Route path="user-management" element={<ViewUsers />} />
          <Route path="access-roles" element={<ViewAccessRoles />} />
          <Route path="earning-deduction" element={<EarningDeductionForm />} />
          <Route path="salary-parameters-form" element={<SalaryParametersForm />} />
          <Route path="leave-master-form" element={<ViewLeaveTypeMaster />} />
          <Route path="holiday-master" element={<ViewHolidayMaster />} />
          <Route path="insert-header" element={<InsertHeaderForm />} />
          <Route path="data-manager" element={<DataManager />} />
        </Route>

        <Route path="employee-master" >
          <Route index element={<EmployeeMasters/>}/>
          <Route path="view-employees" element={<ViewEmployees />}/>
          <Route path="earning-and-deduction-master" element={<EarningAndDeductionMaster/>}/>
        </Route>

        <Route path="intern-apprentice-master" element={<ViewInternApprenticeEmployees />}/>

        <Route path="reports" >
          <Route index element={<Reports/>}/>
          <Route path="salary-report" element={<SalaryReport />}/>
          <Route path="stipend-report" element={<StipendReport />}/>
          <Route path="combine-salary-report" element={<CombineSalaryReport />}/>
          <Route path="income-tax-report" element={<IncomeTaxReport/>}/>
          <Route path="provident-fund-report" element={<ProvidentFundReport />}/>
          <Route path="professional-tax-report" element={<ProfessionalTaxReport/>}/>
          <Route path="bank-statement-report" element={<BankStatementReport/>}/>
          <Route path="esi-statement-report" element={<ESIStatementReport/>}/>
          <Route path="welfare-fund-report" element={<WFStatementReport/>}/>
          <Route path="separation-rate-report" element={<SeparationRateReport/>}/>
          <Route path="gratuity-report" element={<GratuityReport />}/>
          <Route path="top-employees-report" element={<TopEmployeesReport />}/>
          <Route path="combine-salary-report-duration" element={<CombineSalaryReportDuration/>}/>
          <Route path="excel-file-generation" element={<ExcelFileGeneration/>}/>
        </Route>

        <Route path="configure" >
          <Route index element={<Configure />} />
          <Route path="pt-slabs-configure" element={<ViewPTSlabs />} />
          <Route path="pf-rules-configure" element={<PF_RulesConfiguration />} />
          <Route path="ctc-configure" element={<CTC_Configuration/>}/>
          <Route path="esic-configure" element={<ESIC_Configuration />} />
          <Route path="wf-configure" element={<WF_ConfigurationForm />} />
          <Route path="tds-configure" element={<TDS_Configuration_Combined />} />
          <Route path="gratuity-configure" element={<Gratuity_Configuration />} />
          <Route path="income-tax-rules-configure" element={<TDS_Configuration_Combined />} />
        </Route>

        <Route path="employee-master" element={<EmployeeMasters/>}/>
        <Route path="create-payroll">
          <Route index element={<CreatePayroll/>} />         
          <Route path="pdf" element={<PDF/>}/>
          <Route path='salary-slip' element={<SalarySlip />} />
          <Route path="email-send" element={<EmailSendForm />} />
        </Route>
        <Route path="stipend-payroll" element={<StipendPayroll />} />
        <Route path="income-tax" element={<IncomeTax/>}/>
        <Route path="audit-logs" element={<AuditLogs/>}/>
        <Route path="reports" element={<Reports/>}/>
        <Route path='pf-report' element={<PFReport />} />
        <Route path='pf-split-ecr' element={<PFSplitECR />} />
        <Route path='ecr-text-file' element={<ECRTextFile />} />
        <Route path='esi-report' element={<ESIReport />} />
        <Route path='wf-report' element={<WFReport />} />
        <Route path='seperation-report' element={<SeperationReport />} />
        <Route path='gratuity-report-generated' element={<GratuityReportGenerated />} />
        <Route path='top-employees-report-generated' element={<TopEmployeesReportGenerated />} />
        <Route path='combined-salary-report' element={<CombinedSalary />} />
        <Route path='income-tax-report-results' element={<IncomeTaxReportGenerated />} />
        <Route path="configure" element={<Configure/>}/>
        <Route path="bank-statement-report" element={<BankStateReport />}/>
        <Route path="bank-statement-generated" element={<BankStatementGenerated />}/>
        <Route path="test-company-definition" element={<TestCompanyDefinition />}/>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/*    <Masters />
          <EmployeeForm />
          <AddEmployeeForm />
          <EmployeeSalaryForm />
          <DataTable />
          <LeaveMasterForm />
          <CreatePayroll />
          <ESIC_Configuration />
          <PF_RulesConfiguration />
          <PFSlabsConfiguration />

          <CompanyBankAccountsForm />
          <PF_DetailsForm />
          <CombineSalaryReport />
          <ProvidentFundReport />
          <BankStatementReport />
          <ESIStatementReport />
          <SeparationRateReport />
          <CombineSalaryReportDuration />  */}
    </div>
    </ThemeProvider>
  );
}

export default App;
